import http from '../utils/request'

export default {
  // 获取appid
  getAppid() {
    return http.get('/pc/clientApi/on/getParams')
  },
  // 账号密码登录
  login(data) {
    return http.post('/pc/clientApi/on/login', data)
  },
  // 获取用户信息
  getUserInfo() {
    return http.get('/pc/clientApi/account/userInfo')
  },
  // 获取菜单权限信息
  getMenuList() {
    return http.get('/pc/clientApi/on/menuList')
  }
}
